// 引入json文件
import mappingJson from './out_aster.json'

const map = {
  ...mappingJson
}

const enabled = process.env.VUE_APP_MAPPING_ENABLED === 'true'

// 创建反向映射
const reverseMap = {}
Object.keys(map).forEach(key => {
  reverseMap[map[key]] = key
})

// 传出：未映射值 → 映射值
export const encode = (key) => {
  if (key == null) return key
  const keyStr = String(key)
  return enabled && keyStr in map ? map[keyStr] : keyStr
}

// 传入：映射值 → 未映射值
export const decode = (value) => {
  if (value == null) return value
  const valueStr = String(value)
  return enabled && valueStr in reverseMap ? reverseMap[valueStr] : valueStr
}

// 编码整个对象（传出用） 支持数组和嵌套编码key
export const encodeObject = (obj) => {
  if (!obj || typeof obj !== 'object') return obj

  // 如果是数组，递归处理每个元素
  if (Array.isArray(obj)) {
    return obj.map(item => encodeObject(item))
  }

  const encoded = {}
  Object.keys(obj).forEach(key => {
    const encodedKey = encode(key)
    const value = obj[key]

    // 递归处理嵌套对象或数组
    if (value && typeof value === 'object') {
      encoded[encodedKey] = encodeObject(value)
    } else {
      encoded[encodedKey] = value
    }
  })
  return encoded
}

// 解码整个对象（传入用） 需要将内容也解码
export const decodeObject = (obj) => {
  if (!obj || typeof obj !== 'object') return obj

  // 如果是数组，递归处理每个元素
  if (Array.isArray(obj)) {
    return obj.map(item => decodeObject(item))
  }

  const decoded = {}
  Object.keys(obj).forEach(key => {
    const decodedKey = decode(key)
    const value = obj[key]

    // 递归处理嵌套对象和数组
    if (value && typeof value === 'object') {
      decoded[decodedKey] = decodeObject(value)
    } else {
      decoded[decodedKey] = value
    }
  })
  return decoded
}

// 保持原有导出兼容性
export default encode
